import { render, staticRenderFns } from "./DrawingRequestShowChatEvent.vue?vue&type=template&id=bb742f02&"
import script from "./DrawingRequestShowChatEvent.vue?vue&type=script&lang=js&"
export * from "./DrawingRequestShowChatEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports